export * from './foundation-type-2.component';